import React from 'react';
import {connect} from "react-redux";
import getCustomerList from "../../actions/getCustomerList";
import {Form} from 'antd';
import MainLayout from "../Layout/Layout";
import showLogin from "../../actions/showLogin";
import getReportPreview from "../../actions/getReportPreview";
import ReportResultTable from "../ReportResultTable/ReportResultTable";
import {DateRangeFilterItem, ReportFilterActions, ReportFilterHeader} from "../ReportFilters/ReportFilters";
import {decodeBase64ToText, handleBase64Response, parseCsvText} from "../../utils";

class AndesRequests extends React.Component
{
    state={report:null,base64Report:null};

    componentDidMount()
    {
        if(!this.props.login.tokenId || !this.props.login.profileObj)
            this.props.showLogin();
    }

    handleSearch=(formValues)=>
    {
        this.props.getReportPreview("getAndesReport",formValues,(base64Report)=>{
            this.setState({
                base64Report,
                report: parseCsvText(decodeBase64ToText(base64Report))
            });
        });
    };

    handleDownload=()=>
    {
        handleBase64Response(this.state.base64Report,"andes.csv");
    };

    render()
    {
        return <MainLayout title={'logo'} size={'medium'} variant="report"
                           reportTitle="Reporte Andes"
                           reportDescription="Consulta solicitudes Andes por periodo y valida el resultado antes de descargarlo.">
            <Form className="report-filter-panel" layout="vertical" name="andesRequests"
                  onFinish={this.handleSearch}>
                <ReportFilterHeader/>
                <div className="report-filter-fields">
                    <DateRangeFilterItem/>
                </div>
                <ReportFilterActions>Generar reporte</ReportFilterActions>
            </Form>
            <ReportResultTable title="Reporte Andes" parsedReport={this.state.report} onDownload={this.handleDownload}/>
        </MainLayout>;
    }
}

function mapStateToProps(state) {
    return {
        login: state.login
    }
}
export default connect(mapStateToProps, {getCustomerList,showLogin,getReportPreview})(AndesRequests);
